module.exports = __webpack_public_path__ + "img/pitria_no.95c78975.png";